export function initJournalArchive({ gsap = null, ScrollTrigger = null, reducedMotion = false } = {}) {
    const root = document.querySelector('[data-journal-archive]');
    if (!root) return;

    const cards = [...root.querySelectorAll('[data-journal-card]')];
    if (!cards.length || !gsap || !ScrollTrigger || reducedMotion) {
        cards.forEach((card) => {
            card.style.removeProperty('opacity');
            card.style.removeProperty('visibility');
        });
        return;
    }

    const triggers = [];
    cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        if (rect.top <= window.innerHeight + 100) {
            gsap.fromTo(card, { autoAlpha: 0.45 }, {
                autoAlpha: 1,
                duration: 0.55,
                ease: 'power3.out',
                clearProps: 'opacity,visibility',
            });
            return;
        }

        gsap.set(card, { autoAlpha: 0.45 });
        const trigger = ScrollTrigger.create({
            trigger: card,
            start: 'top bottom+=100',
            once: true,
            onEnter: () => gsap.to(card, {
                autoAlpha: 1,
                duration: 0.55,
                ease: 'power3.out',
                clearProps: 'opacity,visibility',
            }),
        });
        triggers.push(trigger);
    });

    window.addEventListener('pagehide', () => triggers.forEach((trigger) => trigger.kill()), { once: true });
}
